import { Component, computed, effect, input, output, signal } from '@angular/core';

import { DirectivesModule } from '@directives/directives.module';
import { ChatMessageData, ChatInput, ChatInputWithIndex, OptionSelectedEvent } from './rebranded-single-selector.types';

@Component({
  selector: 'rebranded-single-selector',
  templateUrl: './rebranded-single-selector.component.html',
  standalone: true,
  imports: [DirectivesModule],
})
export class RebrandedSingleSelectorComponent {
  data = input<ChatMessageData>();
  isClosedTicket = input<boolean>(false);

  static readonly centralImageQuestionIds = ['HairVolume'];

  optionSelected = output<OptionSelectedEvent>();

  selectedIndex = signal(-1);
  submitted = signal(false);

  sortedInputs = computed(() => {
    const inputs: ChatInput[] = this.data()?.get('Inputs') || [];
    return inputs
      .map((each: ChatInput, originalIndex: number) => ({ ...each, originalIndex }))
      .filter((each: ChatInputWithIndex) => each.type !== 'TEXT');
  });

  buttonInputs = computed(() => this.sortedInputs().filter((each: ChatInputWithIndex) => each.type === 'BUTTON'));

  imageInputs = computed(() => this.sortedInputs().filter((each: ChatInputWithIndex) => each.type === 'IMAGE'));

  centraliseImage = computed(() => RebrandedSingleSelectorComponent.centralImageQuestionIds.includes(this.data()?.get('questionId')));

  isEffectivelyClosed = computed(() => {
    if (!this.isClosedTicket()) return false;
    if (!this.data()) return false;
    return this.data()?.get('questionId') !== 'duplicateTicket';
  });

  constructor() {
    effect(() => {
      this.data();
      this.selectedIndex.set(-1);
      this.submitted.set(false);
    });
  }

  sendMessage(): void {
    const originalIndex = this.selectedIndex();
    if (originalIndex < 0) return;
    const item = this.sortedInputs().find((i: ChatInputWithIndex) => i.originalIndex === originalIndex);
    this.optionSelected.emit({ chat: this.data(), index: originalIndex, input: undefined });
    if (item?.action === 'TREE') this.submitted.set(true);
  }
}
